import { render, staticRenderFns } from "./SequenceVersionModal.vue?vue&type=template&id=36931eeb"
import script from "./SequenceVersionModal.vue?vue&type=script&lang=ts"
export * from "./SequenceVersionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports